(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('TkbCard', TkbCard);

    TkbCard.$inject = ['$resource', 'DateUtils'];

    function TkbCard ($resource, DateUtils) {
        var resourceUrl =  'api/tkb-cards/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'deleteByReferenceId': {url: 'api/tkb-cards/:referenceId', method: 'DELETE'},
            'delete': {url: 'api/tkb-cards/:id/delete', method: 'DELETE'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
